// Marca de contenido elegida en el módulo de Contenido ("Mis marcas", sql/139).
// Los services de contenido la usan para leer y guardar solo lo de esa marca.
// Sin marca elegida, la base de datos usa la marca principal del negocio.
let marcaId = null;

export function setMarcaId(id) {
  marcaId = id || null;
}

export function getMarcaId() {
  return marcaId;
}

// Recordar la última marca elegida por negocio (solo comodidad; puede fallar).
const clave = (negocioId) => `kontrol-marca-${negocioId}`;
export function recordarMarca(negocioId, id) {
  try { localStorage.setItem(clave(negocioId), id); } catch { /* sin almacenamiento */ }
}
export function marcaRecordada(negocioId) {
  try { return localStorage.getItem(clave(negocioId)); } catch { return null; }
}
